import React, { Component } from 'react';
import { Icon } from '@blueprintjs/core';

class RouteElementHeading extends Component {
	render() {
		const { icon } = this.props;
		return <div className = 'route_element_heading'>
			<Icon 
				iconSize = { 100 }
				icon = { icon }
			/>
		</div>;
	}
}

export default RouteElementHeading;


// WEBPACK FOOTER //
// ./src/components/home/RouteElementHeading.jsx